jQuery(document).ready(function($) {

  // =================================================
  // SLIDERS
  // =================================================
  
  // Home page synched sliders
  
  var $hpSliderImgSlides = $('.slider-hero__banners'),
      $hpSliderTextSlides = $('.slider-hero__content-outer');
  
  $hpSliderImgSlides.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000,
    asNavFor: $hpSliderTextSlides
  });
  
  $hpSliderTextSlides.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: $hpSliderImgSlides,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
  });
  
  
  // Case study slider
  
  var $csGallery = $('.img-gallery__slides'),
    $csGalleryPrevSlide = $('.img-gallery .slider-nav__btn--prev'),
    $csGalleryNextSlide = $('.img-gallery .slider-nav__btn--next');
  
  $csGalleryPrevSlide.click(function() {
    $csGallery.slick('slickPrev');
    return false;
  });
  
  $csGalleryNextSlide.click(function() {
    $csGallery.slick('slickNext');
    return false;
  });
  
  $csGallery.slick({
    infinite: true,
    dots: false,
    arrows: false,
    fade: false,
    fadeSpeed: 1000,
    slidesToShow: 2,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [{
      breakpoint: 1280,
      settings: {
        slidesToShow: 1,
      }
    }]
  });
  
  var $carouselSlider = $('.carousel__slides');
  
  $carouselSlider.slick({
    infinite: true,
    dots: false,
    arrows: true,
    fade: false,
    fadeSpeed: 1000,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
      breakpoint: 1280,
      settings: {
        slidesToShow: 2,
      }
    }]
  });


  // Testimonial slider
  
  var $testimonialSlider = $('.quote__slides');
  
  $testimonialSlider.slick({
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    adaptiveHeight: true,
    fade: true
  });
  
  // Team slider
  
  var $teamSlider = $('.team-feed .slider');
  
  $teamSlider.slick({
    dots: true,
    infinite: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    infinite: true,
    dots: false,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      }
    ]
  });
  
  // Large slider with counter
  
  var $lgSlider = $('.lg-slider');
  var $lgSliderCounter = $('.lg-slider__counter span');
  var $lgSliderPrevSlide = $('.lg-slider__prev');
  var $lgSliderNextSlide = $('.lg-slider__next');
  
  $lgSlider.on('init reInit afterChange', function(event,slick,currentSlide,nextSlide) {
    var i = (currentSlide ? currentSlide : 0) + 1;
    $lgSliderCounter.text(i + "/" + slick.slideCount);
  });
  
  $lgSliderPrevSlide.click(function() {
    $lgSlider.slick('slickPrev');
    return false;
  });
  
  $lgSliderNextSlide.click(function() {
    $lgSlider.slick('slickNext');
    return false;
  });
  
  $lgSlider.slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    accessibility: false,
    cssEase: 'ease',
    mobileFirst: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: '50px',
          autoplay: false
        }
      }
    ]
  });
  
  // Employee benefits slider
  
  var $empSlider = $('.employee-benefits__slider');
  var $empSliderPrevSlide = $('.employee-benefits__slider__prev');
  var $empSliderNextSlide = $('.employee-benefits__slider__next');
  
  $empSliderPrevSlide.click(function() {
    $empSlider.slick('slickPrev');
    return false;
  });
  
  $empSliderNextSlide.click(function() {
    $empSlider.slick('slickNext');
    return false;
  });
  
  $empSlider.slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    accessibility: false,
    cssEase: 'ease',
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]
  });
  
  // Tier two sliders
  
  var $ttCsSlider = $('.tt-posts--case-studies .slider');
  var $ttCsSliderPrevSlide = $('.tt-posts--case-studies .tt-posts__slider__prev');
  var $ttCsSliderNextSlide = $('.tt-posts--case-studies .tt-posts__slider__next');
  
  $ttCsSliderPrevSlide.click(function() {
    $ttCsSlider.slick('slickPrev');
    return false;
  });
  
  $ttCsSliderNextSlide.click(function() {
    $ttCsSlider.slick('slickNext');
    return false;
  });
  
  $ttCsSlider.slick({
    dots: true,
    infinite: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    infinite: true,
    dots: false,
    autoplay: false,
    arrows: false,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]
  });
  
  var $ttOrSlider = $('.tt-posts--other-reads .slider');
  var $ttOrSliderPrevSlide = $('.tt-posts--other-reads .tt-posts__slider__prev');
  var $ttOrSliderNextSlide = $('.tt-posts--other-reads .tt-posts__slider__next');
  
  $ttOrSliderPrevSlide.click(function() {
    $ttOrSlider.slick('slickPrev');
    return false;
  });
  
  $ttOrSliderNextSlide.click(function() {
    $ttOrSlider.slick('slickNext');
    return false;
  });
  
  $ttOrSlider.slick({
    dots: true,
    infinite: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    infinite: true,
    dots: false,
    autoplay: false,
    arrows: false,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]
  });

  // Data capture form

  $('#popup-form').on('click', function(e) {
    e.preventDefault();

    $('.form-popup .form-validation--success, .form-popup .form-validation--error').hide();

    var first = $('.form-popup input[name="first_name"]').val();
    var last = $('.form-popup input[name="last_name"]').val();
    var email = $('.form-popup input[name="email"]').val();

    if(email) {
      $.ajax({
        url: "/wp-content/themes/ride-shotgun/create-contact.php",
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: '{ "firstname": "' + first + '", "lastname": "' + last + '", "email": "' + email + '" }',
        success: function (data) {
          console.log(data);
          if('status' in data) {
            if('category' in data && data.category == 'CONFLICT') {
              $('.form-popup .form-validation--error').html('<p>Email already exists</p>');
            } else {
              $('.form-popup .form-validation--error').html('<p>Oops! Looks like this is an invalid email address</p>');
            }

            $('.form-validation--error').show();
          } else if(data.isNew == false) {
            $('.form-popup .form-validation--error').html('<p>This email address is already on our mailing list</p>');
            $('.form-popup .form-validation--error').show();
          } else {
            $('.form-popup .form-validation--success').show(); 
          }
        },
        error: function(){
          $('.form-popup .form-validation--error').html('<p>Error: please try submitting the form again</p>');
          $('.form-popup .form-validation--error').show();
        }
      });
    } else {
      $('.form-popup .form-validation--error').html('<p>Please enter your email address</p>');
      $('.form-popup .form-validation--error').show();
    }
  });

  $('#footer-form').on('click', function(e) {
    e.preventDefault();

    $('.pg-footer__form .form-validation--success, .pg-footer__form .form-validation--error').hide();

    var first = $('.pg-footer__form input[name="first_name"]').val();
    var last = $('.pg-footer__form input[name="last_name"]').val();
    var email = $('.pg-footer__form input[name="email"]').val();

    if(email) {
      $.ajax({
        url: "/wp-content/themes/ride-shotgun/create-contact.php",
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: '{ "firstname": "' + first + '", "lastname": "' + last + '", "email": "' + email + '", "source": "footer-form" }',
        success: function (data) {
          console.log(data);
          if('status' in data) {
            if('category' in data && data.category == 'CONFLICT') {
              $('.pg-footer__form .form-validation--error').html('<p>Email already exists</p>');
            } else {
              $('.pg-footer__form .form-validation--error').html('<p>Oops! Looks like this is an invalid email address</p>');
            }

            $('.pg-footer__form .form-validation--error').show();
          } else if(data.isNew == false) {
            $('.pg-footer__form .form-validation--error').html('<p>This email address is already on our mailing list</p>');
            $('.pg-footer__form .form-validation--error').show();
          } else {
            $('.pg-footer__form .form-validation--success').show(); 
          }
        },
        error: function(){
          $('.pg-footer__form .form-validation--error').html('<p>Error: please try submitting the form again</p>');
          $('.pg-footer__form .form-validation--error').show();
        }
      });
    } else {
      $('.pg-footer__form .form-validation--error').html('<p>Please enter your email address</p>');
      $('.pg-footer__form .form-validation--error').show();
    }
  });

  $('#about-form').on('click', function(e) {
    e.preventDefault();

    $('.pg-about__form .form-validation--success, .pg-about__form .form-validation--error').hide();

    var name = $('.pg-about__form input[name="name"]').val();
    var email = $('.pg-about__form input[name="email"]').val();
    var phone = $('.pg-about__form input[name="phone"]').val();
    var message = $('.pg-about__form textarea[name="message"]').val();

    if(email) {
      $.ajax({
        url: "/wp-content/themes/ride-shotgun/send-email.php",
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: '{ "name": "' + name + '", "email": "' + email + '", "phone": "' + phone + '", "message": "' + message + '", "source": "about-form" }',
        success: function (data) {
          $('.pg-about__form .form-validation--success').show(); 
        },
        error: function(){
          $('.pg-about__form .form-validation--error').html('<p>Error: please try submitting the form again</p>');
          $('.pg-about__form .form-validation--error').show();
        }
      });
    } else {
      $('.pg-about__form .form-validation--error').html('<p>There is an error with your submission. Please try again.</p>');
      $('.pg-about__form .form-validation--error').show();
    }
  });

  $('#contact-form').on('click', function(e) {
    e.preventDefault();

    $('.pg-contact__form .form-validation--success, .pg-contact__form .form-validation--error').hide();

    var name = $('.pg-contact__form input[name="name"]').val();
    var email = $('.pg-contact__form input[name="email"]').val();
    var phone = $('.pg-contact__form input[name="phone"]').val();
    var message = $('.pg-contact__form textarea[name="message"]').val();

    if(email) {
      $.ajax({
        url: "/wp-content/themes/ride-shotgun/send-email.php",
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: '{ "name": "' + name + '", "email": "' + email + '", "phone": "' + phone + '", "message": "' + message + '", "source": "contact-form" }',
        success: function (data) {
          $('.pg-contact__form .form-validation--success').show(); 
        },
        error: function(){
          $('.pg-contact__form .form-validation--error').html('<p>Error: please try submitting the form again</p>');
          $('.pg-contact__form .form-validation--error').show();
        }
      });
    } else {
      $('.pg-contact__form .form-validation--error').html('<p>There is an error with your submission. Please try again.</p>');
      $('.pg-contact__form .form-validation--error').show();
    }
  });

  $('#job-form').on('click', function(e) {
    e.preventDefault();

    $('.pg-job__form .form-validation--success, .pg-job__form .form-validation--error').hide();

    var name = $('.pg-job__form input[name="name"]').val();
    var email = $('.pg-job__form input[name="email"]').val();
    var phone = $('.pg-job__form input[name="phone"]').val();
    var message = $('.pg-job__form textarea[name="message"]').val();

    if(email) {
      $.ajax({
        url: "/wp-content/themes/ride-shotgun/send-email.php",
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: '{ "name": "' + name + '", "email": "' + email + '", "phone": "' + phone + '", "message": "' + message + '", "source": "job-form" }',
        success: function (data) {
          $('.pg-job__form .form-validation--success').show(); 
        },
        error: function(){
          $('.pg-job__form .form-validation--error').html('<p>Error: please try submitting the form again</p>');
          $('.pg-job__form .form-validation--error').show();
        }
      });
    } else {
      $('.pg-job__form .form-validation--error').html('<p>There is an error with your submission. Please try again.</p>');
      $('.pg-job__form .form-validation--error').show();
    }
  });

  
  // =================================================
  // SCROLL BACK TO TOP MIXITUP PAGINATION
  // =================================================
  
  $(document).on('click', '.mixitup-control', function() {
    window.scrollTo(0, 0);
  });

  $(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
        $('.pg-header').addClass('pg-header__up');
     } else {
        $('.pg-header').removeClass('pg-header__up');
     }
  });
  
  
});